import { render, staticRenderFns } from "./AgentScanButton.vue?vue&type=template&id=709d58ca&scoped=true"
import script from "./AgentScanButton.vue?vue&type=script&lang=js"
export * from "./AgentScanButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709d58ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('709d58ca')) {
      api.createRecord('709d58ca', component.options)
    } else {
      api.reload('709d58ca', component.options)
    }
    module.hot.accept("./AgentScanButton.vue?vue&type=template&id=709d58ca&scoped=true", function () {
      api.rerender('709d58ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Agent/AgentScanButton.vue"
export default component.exports